import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import _ from 'lodash';

// Components
import { SelectInput } from 'components/forms/form-elements';

export default function RateSelect({ currentRate, rates, afterHours, afterHoursPremium, input, ...props }) {
  const ratesForDisplay = [...rates, {
    id: 0,
    rate: 0,
    role: 'Included in agreement'
  }];

  if (input.value && !_.find(ratesForDisplay, { id: input.value })) {
    const legacyRole = `(legacy) ${currentRate.role}`;
    const legacyRate = _.assign({ role: legacyRole }, _.pick(currentRate, ['id', 'rate']));
    ratesForDisplay.push(legacyRate);
  }

  return (
    <SelectInput
      {...props}
      input={input}
      options={ratesForDisplay}
      valueKey="id"
      labelKey="title"
      clearable={false}
      optionRenderer={(option) => renderRateOption(option, { afterHours, afterHoursPremium })}
      valueRenderer={(option) => renderRateOption(option, { afterHours, afterHoursPremium })}
    />
  );
}

RateSelect.propTypes = {
  rates: PropTypes.array.isRequired,
  currentRate: PropTypes.object,
  input: PropTypes.object,
  afterHours: PropTypes.bool,
  afterHoursPremium: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};


function currency(amount) {
  return numeral(Number(amount)).format('$0,0[.]00');
}

function renderRateOption(option, { afterHours, afterHoursPremium }) {
  const total = afterHours ? Number(option.rate) + Number(afterHoursPremium) : option.rate;

  return (
    <div>
      {option.role} - {currency(total)}
      { (afterHours && afterHoursPremium !== 0) &&
        <span className="deemphasize" style={{ marginLeft: '5px' }}>
          ({currency(option.rate)} + {currency(afterHoursPremium)})
        </span>
      }
    </div>
  );
}
